const LEGACY_DATABASE = 'ruuts-rpd'

// Temporary: the IndexedDB storage layer removed in v1.15.0 left this database in every browser
// that ran an earlier release, and nothing else would ever delete it. Remove this module and its
// call in index.tsx once v1.18.0 has shipped.
// A deletion blocked by another open tab completes when that tab closes; any refusal is ignored
// because the boot must never depend on it.
export const deleteLegacyStorage = (): void => {
  try {
    if (typeof indexedDB !== 'undefined') indexedDB.deleteDatabase(LEGACY_DATABASE)
  } catch {
    // no-op: see above
  }
}
